<template>
  <div class="Breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        :to="item.path"
        v-for="(item, index) in breadcrumbList"
        :key="index"
        >{{ $t("NavMenu." + item.meta.title) }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumbList: [],
    };
  },
  created() {
    this.getBreadcrumb();
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    isHome(route) {
      console.log(route)
      return route.name === "HomePage";
    },
    getBreadcrumb() {
      console.log(this.$route.matched)
      let matched = this.$route.matched;
      if (!this.isHome(matched[0])) {
        matched = matched;
      }
      this.breadcrumbList = matched;
    },
  },
};
</script>

<style lang="less" scoped>
.Breadcrumb {
  width: 100%;
  height: 38px;
  padding: 11px 0 0;
  box-sizing: border-box;
  /deep/.el-breadcrumb__inner {
    font-size: 12px;
    color: #fff;
  }
  /deep/.el-breadcrumb__inner a,
  /deep/.el-breadcrumb__inner.is-link {
    font-size: 12px;
    color: #fff;
  }
  /deep/.el-breadcrumb span:nth-last-child(1) span {
    font-size: 12px;
    color: #409eff;
  }
}
</style>
